import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { PickerInput } from '../../atoms';
import { Text } from '../../../../../components';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

const MonthPicker = ({ setMonthDay }) => (
  <StyledContainer>
    <Text>Day</Text>
    <PickerInput max={31} setFrequency={setMonthDay} />
    <Text>of the month</Text>
  </StyledContainer>
);

MonthPicker.propTypes = {
  setMonthDay: PropTypes.func.isRequired
};

export { MonthPicker };
